import { axios } from '@/lib/axios';

export const buyBasicPlan = (id: string): Promise<void> => {
  const payload = {
    subscription_id: id,
  };
  return axios.post('subscription-api/buy-basic-lawyer-plan', payload);
};
